import React, { Fragment } from 'react';
import styled from 'styled-components';

import { isAdBreak } from '../../../common/utils';
import { AdUnitLoadingUI } from '../common/adUnitLoadingUI';
import { numberOfHourlyCardLoading } from '../common/placeholderUtils';
import { SolarDivideLoadingUI } from '../common/solarDivideLoadingUI';
import { LargeHourCardItemLoadingUI } from './largeHourCardItemLoadingUI';

export const LargeHourCardListItemsLoadingUI = () => {
    return (
        <Container>
            {
                numberOfHourlyCardLoading?.map(cardItemNumber => {
                    return (
                        <Fragment key={`loading-hour-card-fragment#${cardItemNumber}`}>
                            {
                                cardItemNumber === 3 
                                    ? <SolarDivideLoadingUI key='solar-divide-placeholder'/>
                                    : null
                            }

                            <LargeHourCardItemLoadingUI key={`large-hour-card-loading-ui#${cardItemNumber}`} />

                            {
                                isAdBreak(cardItemNumber, false)
                                    ? <AdUnitLoadingUI key='ad-break-placeholder'/>
                                    : null
                            }
                        </Fragment>
                    );
                })
            }
        </Container>
    );
};

const Container = styled.ul`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    width: auto;
    list-style-type: none;
    padding: 0;
    min-height: 260px;
`;